module.exports = __webpack_public_path__ + "static/media/csvExampleImg.2b7b471d.png";